import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AICoachingKpiOrganizationAveragesDto } from 'src/core/models/coaching-and-training/ai-coaching-kpi-organization-averages.dto';
import { AICoachingReportDto } from 'src/core/models/coaching-and-training/ai-coaching-report.dto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CoachingAndTrainingService {
  constructor(private http: HttpClient) {}

  getUserReports(
    periodId: Number,
    userId: string,
  ): Observable<AICoachingReportDto[]> {
    const url = this.getApiUrl() + '/' + periodId + '/report/' + userId;

    return this.http.get(url) as Observable<AICoachingReportDto[]>;
  }

  getKpiOrganizationAverages(): Observable<AICoachingKpiOrganizationAveragesDto> {
    return this.http.get<AICoachingKpiOrganizationAveragesDto>(
      this.getApiUrl() + '/kpi-organization-averages',
    );
  }

  private getApiUrl(): string {
    const apiBase = environment.apis.default.url;

    return apiBase + '/' + AICoachingReportDto.apiUrl;
  }
}
